module.exports = __webpack_public_path__ + "static/media/signage-indoor-img25.31d99c30.jpg";